import Box from '@mui/system/Box';
import {memo} from 'react';

const MUIBox = (props: any): any => {
    const {children, component, className, src, alt, id, ...rest} = props;
    return (
        <Box component={component} className={className} src={src} alt={alt} id={id} {...rest}>
            {children}
        </Box>
    );
};

export default memo(MUIBox);
